export const ALL_OPTION_VALUE = "__ALL__";
export const DEFAULT_UNIT = "kgCO2e/kg";
